import { OutlookCard } from '@crm/features/integrations/components'
import { TitleSection } from '@shared/components'
import { Card, Col, Row } from 'antd'
import { useTranslation } from 'react-i18next'

export const Integrations = () => {
  const { t } = useTranslation()

  return (
    <>
      <TitleSection title={t('account_settings.integrations')} />

      <Card>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <OutlookCard />
          </Col>
        </Row>
      </Card>
    </>
  )
}
